module.exports = __webpack_public_path__ + "img/character_details.017cb3fe.png";